import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { UserStatus } from './types';
import { map, switchMap, take } from 'rxjs/operators';

export const activeGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.user$.pipe(
    take(1),
    switchMap((user) => {
      if (user) {
        return [user];
      }

      return authService.getUser().pipe(take(1));
    }),
    map((user) => {
      if (!user) {
        void router.navigate(['/']);
        return false;
      }
      if (user.status === UserStatus.Active) {
        return true;
      }

      if (!user.profileCompleted) {
        void router.navigate(['/auth/register'], { queryParams: { completeProfile: 'true' } });
        return false;
      }

      if (user.status === UserStatus.PendingApproval) {
        void router.navigate(['/auth/pending-approval']);
        return false;
      }

      if (user.status === UserStatus.Rejected) {
        authService.applyAuthError({
          code: 'rejected',
          message: 'Your registration request was not approved.',
        });
        void router.navigate(['/auth/login']);
        return false;
      }

      if (user.status === UserStatus.Suspended) {
        authService.applyAuthError({
          code: 'suspended',
          message: 'Your account is currently suspended.',
        });
        void router.navigate(['/auth/login']);
        return false;
      }

      void router.navigate(['/auth/login']);
      return false;
    })
  );
};
